<template>
    <div>
        <fieldset>
            <div style="padding: 20px;">
                <div class="row">
                    <div class="col-md-3">
                        <label for="template_type">First name</label>
                        <input type="text" id="first_name" placeholder="First name"  v-model="$parent.tour_manage.firstname" required>
                    </div>
                    <div class="col-md-3">
                        <label for="template-name">Last name</label>
                        <input type="text" id="last_name" placeholder="Last name"  v-model="$parent.tour_manage.lastname" required>
                    </div>
                    <div class="col-md-3">
                        <label for="template_subject">Email</label>
                        <input id="email" type="text" placeholder="Email"  v-model="$parent.tour_manage.email" required>
                    </div>
                    <div class="col-md-3">
                      <label for="template_subject">Mobile number</label>
                        <input id="mobile_number" class="gray-readonly-input" type="text" placeholder="Mobile number"  v-model="$parent.tour_manage.mobile_number" required>
                    </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-3">
                      <label for="template_subject">Telephone number</label>
                      <input id="telephone_number" class="gray-readonly-input" type="text" placeholder="Telephone number" v-model="$parent.tour_manage.telephone_number" required>
                  </div>
                  <div class="col-md-3">
                    <label for="address">Address</label>
                    <textarea id="address" style="max-width: 100%; min-height: 8rem" v-model="$parent.tour_manage.address"></textarea>
                  </div>
                </div>
                <hr>
                <h4>Bank Details</h4>
                <hr>
                <div class="row">
                    <div class="col-md-3">
                        <label for="template_type">IBAN number</label>
                        <input type="text" id="template-name" placeholder="IBAN number" v-model="$parent.tour_manage.iban_number">
                    </div>
                    <div class="col-md-3">
                        <label for="template-name">BIC/Swift</label>
                        <input type="text" id="template-name" placeholder="BIC/Swift" v-model="$parent.tour_manage.bic_swift_number">
                    </div>
                    <div class="col-md-3">
                        <label for="template_subject">Account number</label>
                        <input id="template_subject" type="text" placeholder="Account number"  v-model="$parent.tour_manage.account_number">
                    </div>
                    <div class="col-md-3">
                      <label for="template_subject">Sort code</label>
                        <input id="template_subject" class="gray-readonly-input" type="text" placeholder="Sort code" v-model="$parent.tour_manage.sort_code">
                    </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-3">
                      <label for="template_subject"> Bank name </label>
                        <input id="template_subject" class="gray-readonly-input" type="text" placeholder="Bank name" v-model="$parent.tour_manage.bank_name">
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
  </template>
  
<script>
  
  export default {

    name: 'TourManagerFields',
    
    data () {
      return {
        
      }
    },
    methods: {
      
    }
  }
</script>

  